<template>
  <div class="about">
    <DashHeader />
    <div class="page">
      <h1>How the Popular Vote SnapShot is Determined</h1>
      <p class="text_info">
        Popular Vote snapshot is the
        <a href="https://fivethirtyeight.com">FiveThirtyEight</a> weighted average of all nationwide polls on the presidential election in November. FiveThirtyEight's weighting adjusts for poll quality, recency, sample size, and partisan lean. </p>
        <p>The gauge shows a maximum of plus or minus 25 points, based on the largest victory by either party in the past 100 years, which was Warren Harding 26 point victory over James Cox in 1920.
      </p>

      <p>
        <router-link class="page_nav_button" to="/">Back Dashboard</router-link>
      </p>
    </div>
  </div>
</template>
<script>
import DashHeader from "@/components/DashHeader.vue";
export default {
  name: "AboutPopularVote",
  components: {
    DashHeader
  }
};
</script>
